import { render, staticRenderFns } from "./ContactusCard.vue?vue&type=template&id=45a49cc7&scoped=true&"
import script from "./ContactusCard.vue?vue&type=script&lang=js&"
export * from "./ContactusCard.vue?vue&type=script&lang=js&"
import style0 from "./ContactusCard.vue?vue&type=style&index=0&id=45a49cc7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a49cc7",
  null
  
)

export default component.exports